import './CheckBox.css'
import { useCallback, type ChangeEvent, type Dispatch, type InputHTMLAttributes, type ReactNode, type SetStateAction } from 'react'
import { cn } from '@/utilities/misc'
import { Icon } from '@/components/graphics/Icon'
import { Tooltip } from '@/components/action/Tooltip'
import type { Placement } from '@floating-ui/dom'

export type CheckBoxProps =
  Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> &
  {
    value?: boolean,
    label?: ReactNode,
    tooltip?: ReactNode
    tooltipPlacement?: Placement
    frameClassName?: string
    setValue?: Dispatch<SetStateAction<boolean>>,
  }

export function CheckBox({
  label,
  tooltip,
  tooltipPlacement,
  frameClassName,
  disabled,
  value,
  onChange,
  setValue,
  ...rest
}: CheckBoxProps) {

  const handleChange = useCallback((ev: ChangeEvent<HTMLInputElement>) => {
    if (onChange)
      onChange(ev)
    if (setValue)
      setValue(ev.target.checked)
  }, [setValue, onChange])

  return (
    <label className={cn('CheckBox', frameClassName)}>
      <Tooltip placement={tooltipPlacement} disabled={disabled}>
        {tooltip}
      </Tooltip>
      <input
        type='checkbox'
        className='CheckBox-input'
        checked={value}
        onChange={ev => handleChange(ev)}
        disabled={disabled}
        {...rest}
      />
      <span className='Box'>
        <span className='CheckBox-check'>
          <Icon icon='check' />
        </span>
      </span>
      {value}
      {label != null && <span className='Text'>{label}</span>}
    </label>
  )
}
